import axios from "axios";
import { checkEnvType } from "src/helper";

const isDevelopment = checkEnvType();
const API_URL = isDevelopment ? process.env.REACT_APP_API_DEV_URL : process.env.REACT_APP_API_PROD_URL;

const getFrontPage = async () => {
  return await axios
    .get(API_URL + "users/frontPage")
    .then((response) => {
      return response.data;
    });
};

const frontPageService = { getFrontPage };
export default frontPageService;